import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { observer } from 'mobx-react'
import SearchBar from './SearchBar'
import Table from './Table'
import Store from './store'
import { ACTIVITY_DIY_PATH } from '@constant'
import { hashHistory } from 'react-router'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(this.props.store)
  }
  toEditActivity = () => {
    hashHistory.push(ACTIVITY_DIY_PATH)
    this.props.store.initModalVisible()
  }
  openCoverModal = () => {
    this.props.store.showCoverModal()
  }
  render() {
    const { listModalVisible, operateModal } = this.props.store
    return (
      <Modal
        title="选择模板"
        visible={listModalVisible}
        width={800}
        onCancel={operateModal('listModalVisible')}
        footer={
          <>
            <Button type="primary" onClick={this.toEditActivity}>
              新建活动
            </Button>,
            <Button type="primary" onClick={this.openCoverModal}>
              下一步
            </Button>
          </>
        }
      >
        <SearchBar store={this.store} />
        <Table store={this.store} indexStore={this.props.store} />
      </Modal>
    )
  }
}
